<template>
  <span :class="{'positive': secs > 0, 'non-positive': secs <= 0}">{{ secs }}</span>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    endDate: {
        type: Date,
        required: true
    },
  },
  data() {
    return {
      secs: null
    };
  },
  mounted() {
    this.intervalId = setInterval(() => {
      const now = new Date();
      if ( this.endDate )
        this.secs = Math.floor((this.endDate - now) / 1000);    
        
      if ( this.secs <= 0){
          clearInterval(this.intervalId)
      }
    }, 1000);
  }
};
</script>
</script>

<style scoped>
.positive {
  color: green;
}

.non-positive {
  color: red;
}
</style>